import type { FixturePerson } from "~types/fixturePerson.ts";
import type { FixtureResources } from "~types/fixture.ts";
import { sortStringValues } from "~utils/utilities.ts";

export const getFixtureParticipantsNames = (
  isHome: boolean,
  notSpecified: string,
  participants: FixturePerson[] | undefined = [],
  resources: FixtureResources | undefined = {},
) => {
  return (participants || [])
    .filter((x) => x.isHome === isHome)
    .map((x) => resources?.[x.person.resourceType]?.[x.person.id]?.nameFullLocal)
    .sort((a, b) => sortStringValues(a || notSpecified, b || notSpecified))
    .join("/");
};